import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuComponent } from './menu/menu.component';
import { DataComponent } from './data/data.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './login/login.component';
import { ModalforgotpasswordComponent } from './modalforgotpassword/modalforgotpassword.component';
import { ComponenteData1Component } from './componente-data1/componente-data1.component';
import { ComponenteData2Component } from './componente-data2/componente-data2.component';
import { ComponenteData3Component } from './componente-data3/componente-data3.component';
import { ComponenteData4Component } from './componente-data4/componente-data4.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables'; //se instala de aca: https://l-lin.github.io/angular-datatables/#/getting-started
import * as firebase from 'firebase'; //se instala de aca: npm install --save firebase
import { AngularFireModule } from '@angular/fire'; //se instala de aca: ng add @angular/fire
import { HttpClientModule } from '@angular/common/http';
import {AngularFireFunctionsModule,} from '@angular/fire/functions';
import { RangodefechasComponent } from './rangodefechas/rangodefechas.component';
import { ModalDataUsuarioComponent } from './modal-data-usuario/modal-data-usuario.component';
import { ModalAccionesUsuarioComponent } from './modal-acciones-usuario/modal-acciones-usuario.component';
import { ComponenteData5Component } from './componente-data5/componente-data5.component';
import { ModalAccionesAutoridadComponent } from './modal-acciones-autoridad/modal-acciones-autoridad.component';
import { ModalAccionesEmpresaComponent } from './modal-acciones-empresa/modal-acciones-empresa.component';
import { ComponenteData6Component } from './componente-data6/componente-data6.component';
import { ModalAccionesLoccionesComponent } from './modal-acciones-locciones/modal-acciones-locciones.component';

import { NgxChartsModule }from '@swimlane/ngx-charts';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {IconsModule} from './icons/icons.module';
import { ModalHerramientasYControlesComponent } from './modal-herramientas-ycontroles/modal-herramientas-ycontroles.component';
import { ModalDetallesActividadComponent } from './modal-detalles-actividad/modal-detalles-actividad.component';
import { ModalDatasetComponent } from './modal-dataset/modal-dataset.component';
import { ComponenteData7Component } from './componente-data7/componente-data7.component'

var config = {
  apiKey: "AIzaSyCR9JzAvg7blumth9rpCcxgckHSDr6M7MA",
  authDomain: "gt-ptw.firebaseapp.com",
  databaseURL: "https://gt-ptw.firebaseio.com",
  projectId: "gt-ptw",
  storageBucket: "gt-ptw.appspot.com",
  messagingSenderId: "526164954130",
  appId: "1:526164954130:web:598790b2a4b378fb1c5ccb"
};

AngularFireModule.initializeApp(config);
firebase.initializeApp(config);


@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    DataComponent,
    LoginComponent,
    ModalforgotpasswordComponent,
    ComponenteData1Component,
    ComponenteData2Component,
    ComponenteData3Component,
    ComponenteData4Component,
    RangodefechasComponent,
    ModalDataUsuarioComponent,
    ModalAccionesUsuarioComponent,
    ComponenteData5Component,
    ModalAccionesAutoridadComponent,
    ModalAccionesEmpresaComponent,
    ComponenteData6Component,
    ModalAccionesLoccionesComponent,
    ModalHerramientasYControlesComponent,
    ModalDetallesActividadComponent,
    ModalDatasetComponent,
    ComponenteData7Component,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    NgxDatatableModule,
    FormsModule,
    DataTablesModule,
    AngularFireModule.initializeApp(config),
    BrowserAnimationsModule,
    NgxChartsModule,
    IconsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
